<div class="row col-12 col-sm-12 manage-user-container my-account-container">
  <div class="col-3 col-sm-3 left-side my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyOrdersNavNode'"
    [childNavState]="'SavedShoppingCartNavNode'"></app-my-account-left-sidenav>
  </div>

  <div class="myAccountMyProfile col-12 col-sm-12 col-md-12 col-lg-9 right-side my-account-right-nav">
    <h1 class="manageUserTopHeader m-0">{{'common.text_account_savedCarts_ShoopingCart'|cxTranslate}}
    </h1>

    @if (savedCart && savedCart.searchRetsults?.length>0) {
      <div class="sort-section my-section-box"
        >
        <div class="gray-search-result-box">
          {{totalResults}}<div class="d-md-none d-lg-none">
          <div class="mobile-select">
            <span class="mobile-select-label">Sort by:</span>
            <div class="select-box">
              <select class="mobile-sorting-dropdown form-control" name="sort">
                <option selected="selected">
                Date-Desc</option>
                <option>
                Date-Asc</option>
                <option>
                Name-Asc</option>
                <option>
                Name-Desc</option>
                <option>
                Email-Asc</option>
                <option>
                Email-Desc</option>
                <option>
                Active-Asc</option>
                <option>
                Active-Desc</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="saved-shopping-cart-table mycompany-manageUser">
        <table class="responsive-table table table-bordered table-blue savedShoppingCartTable">
          <thead>
            <tr class="responsive-table-head hidden-xs hidden-sm">
              <th scope="col">
                <a class="a-underline"
                  (click)="sort('name')"><span>{{'common.text_account_savedCart_name'|cxTranslate}}</span>
                  @if (sortNameType=='asc') {
                    &#8593;
                  }
                  @if (sortNameType=='desc') {
                    &#8595;
                  }
                </a>
              </th>
              <th scope="col">
                <a class="a-underline"
                  (click)="sort('id')"><span>{{'common.text_account_savedcart_cart_id'|cxTranslate}}</span>
                  @if (sortIdType=='asc') {
                    &#8593;
                  }
                  @if (sortIdType=='desc') {
                    &#8595;
                  }
                </a>
              </th>
              <th scope="col">
                <a class="a-underline" (click)="sort('date')"><span>
                {{'common.text_account_addressBook_page_sort_byDateSaved'|cxTranslate}}</span>
                @if (sortDateType=='asc') {
                  &#8593;
                }
                @if (sortDateType=='desc') {
                  &#8595;
                }
              </a>
            </th>
            <th scope="col">{{'common.text_account_savedCart_description'|cxTranslate}}</th>
            <th scope="col">{{'common.text_account_savedCart_position'|cxTranslate}}</th>
            <th scope="col">{{'common.text_account_savedCart_remove'|cxTranslate}}</th>
          </tr>
        </thead>
        @if (savedCart) {
          <tbody>
            @for (item of savedCart?.searchRetsults; track item) {
              <tr class="responsive-table-item">
                <td class="responsive-table-cell name">
                  <span
                  class="d-lg-none saved-cart-label">{{'common.text_account_savedCart_name'|cxTranslate}}</span>
                  <a [routerLink]="['/saved-carts',item.code]" (click)="redirectCart(item)"> <span
                    style="color: #154680;"
                  class="mycompnay-registration-value pointer cursor">{{item.name}}</span></a>
                </td>
                <td class="responsive-table-cell email">
                  <span
                  class="d-lg-none saved-cart-label">{{'common.text_account_savedcart_cart_id'|cxTranslate}}</span>
                  <span class="mycompnay-registration-value pointer">{{item.code}}</span>
                </td>
                <td class="responsive-table-cell email">
                  <span
                  class="d-lg-none saved-cart-label">{{'common.text_account_addressBook_page_sort_byDateSaved'|cxTranslate}}</span>
                  <span class="mycompnay-registration-value pointer">{{formatDate(item.saveTime,
                  savedCart.dateFormat)}}</span>
                </td>
                <td class="responsive-table-cell email">
                  <span
                  class="d-lg-none saved-cart-label">{{'common.text_account_savedCart_description'|cxTranslate}}</span>
                  <span class="mycompnay-registration-value pointer">{{item.description}}</span>
                </td>
                <td class="responsive-table-cell email">
                  <span
                  class="d-lg-none saved-cart-label">{{'common.text_account_savedCart_position'|cxTranslate}}</span>
                  <span class="mycompnay-registration-value pointer">{{item.entries.length}}</span>
                </td>
                <td class="responsive-table-cell email action-col restore-button">
                  <span
                  class="d-none d-sm-none d-md-none saved-cart-label">{{'common.text_account_savedCart_remove'|cxTranslate}}</span>
                  <span>
                    <button
                    (click)="restore(item)">{{'common.text_account_savedCart_restore'|cxTranslate}}</button>
                    <img class="d-none d-sm-none d-md-none d-lg-block" src="/icons/remove.png"
                      (click)="deleteSavedCart(item)">
                    </span>
                  </td>
                  <td class="responsive-table-cell d-lg-none action-col saved-remove-button">
                    <img src="/icons/remove.png" (click)="deleteSavedCart(item)" alt="Delete Saved Cart">
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
      <div class="account-orderhistory-pagination company-users-pagination">
        <div class="product__list--wrapper">
          <div class="pagination-bar saved-cart-pagination">
            <div class="pagination-toolbar">
              <div class="row sort-refine-bar">
                <div class="col-xs-12 col-sm-6 col-md-6 bottom-result">
                  <div class="pagination-result">
                  {{pageItems}} </div>
                </div>
                <div
                  class="col-xs-12 col-sm-6 col-md-6 kb-pagination-right kb-pagination d-flex align-items-center">
                  <kb-pagination [pagination]="savedCart?.pagination" [defaultPage]="0"
                  (viewPageEvent)="changePageCustom($event)"></kb-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    @if (savedCart) {
      <strong class="d-flex justify-content-center empty-saved-cart">
        {{'common.text_account_savedCarts_noSavedCarts'|cxTranslate}}
      </strong>
    }
  }

</div>
</div>